theme.SlideShow = (function () {
  function Slider(e) {
    // console.log("slideshow loaded:", e)
    let sliderWrapper = e.querySelector(".hero__slider--activation"),
      slideLoop = e.dataset.slideLoop,
      slideAutoplay = e.dataset.slideAutoplay,
      autoplayDuration = e.dataset.autoplayDuration,
      slideLoopValue = true,
      autoplay = false,
      slideNavPrev = e.querySelector(".swiper-button-prev"),
      slideNavNext = e.querySelector(".swiper-button-next"),
      sliderPagination = e.querySelector(".swiper-pagination"),
      slideShowSpace = parseInt(e.dataset.slideshow)
        ? parseInt(e.dataset.slideshow)
        : 10,
      slidesPerView = parseInt(e.dataset.slidesperview)
        ? parseInt(e.dataset.slidesperview)
        : 4,
      smallDesktop = parseInt(e.dataset.smalldesktopview)
        ? parseInt(e.dataset.smalldesktopview)
        : 3,
      tabletShow = parseInt(e.dataset.showTablet)
        ? parseInt(e.dataset.showTablet)
        : 2,
      mobileShow = parseInt(e.dataset.showMobile)
        ? parseInt(e.dataset.showMobile)
        : 1;

    // console.log("slidesPerView:", slidesPerView);

    // Count slides to determine if loop is possible
    var slideCount = sliderWrapper ? sliderWrapper.querySelectorAll(".swiper-slide").length : 0;

    if (slideLoop == "false") {
      slideLoopValue = false;
    }
    // Disable loop if not enough slides (need more slides than slidesPerView)
    if (slideCount <= slidesPerView) {
      slideLoopValue = false;
    }
    if (slideAutoplay == "true") {
      let sliderDuration = parseInt(autoplayDuration);
      autoplay = { delay: autoplayDuration, disableOnInteraction: false };
    }

    var swiper = new Swiper(sliderWrapper, {
      slidesPerView: slidesPerView,
      autoplay: autoplay,
      loop: slideLoopValue,
      clickable: true,
      speed: 1000,
      spaceBetween: slideShowSpace,
      pagination: {
        el: sliderPagination,
        clickable: true,
      },
      navigation: {
        nextEl: slideNavNext,
        prevEl: slideNavPrev,
      },
      breakpoints: {
        0: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: smallDesktop,
        },
        1200: {
          slidesPerView: slidesPerView,
        },
      },
    });
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return Slider;
})();
